import {RouterStateSerializer} from '@ngrx/router-store';
import {RouterStateSnapshot} from '@angular/router';

interface CustomRouterState {
  url: string;
  params: unknown;
  queryParams: unknown;
  data: unknown;
}


export class CustomRouterStateSerializer implements RouterStateSerializer<CustomRouterState> {
  serialize(routerState: RouterStateSnapshot): CustomRouterState {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return {
      url: routerState.url || '/',
      params: route.params,
      queryParams: routerState.root.queryParams,
      data: route.data
    } as CustomRouterState;
  }
}
